import { Component } from '@angular/core';
import { MaterialModule } from '../../../../modules/material.module';
import { SEARCH_OPTIONS_DIALOGS } from '../utils/constant';

@Component({
  selector: 'app-search-options-dialog',
  standalone: true,
  imports: [MaterialModule],
  templateUrl: './search-options-dialog.component.html',
  styleUrl: './search-options-dialog.component.scss',
})
export class SearchOptionsDialogComponent {
  columns = SEARCH_OPTIONS_DIALOGS.COLUMNS;
  searchData = SEARCH_OPTIONS_DIALOGS.DETAILS;
}
